import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../styles/list.css";

export default function List({ items, itemStyle = "tick" }) {
  return (
    <ul className="list">
      {items.map((item, index) => (
        <li key={index} className="list-item">
          {itemStyle === "tick" && (
            <FontAwesomeIcon icon={faCheck} className="list-item-tick" />
          )}
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
